import { Iterable } from "@siteimprove/alfa-iterable";
import { Map } from "@siteimprove/alfa-map";
import { Cookie } from "./cookie.js";
/**
 * @public
 */
export class Cookies {
    /**
     * @remarks
     * If the iterable contains cookies with duplicate names, the last cookie with
     * a given name will take precedence.
     */
    static of(cookies) {
        return new Cookies(Map.from(Iterable.map(cookies, (cookie) => [cookie.name, cookie])));
    }
    static _empty = new Cookies(Map.empty());
    static empty() {
        return this._empty;
    }
    _cookies;
    constructor(cookies) {
        this._cookies = cookies;
    }
    get(name) {
        return this._cookies.get(name);
    }
    has(name) {
        return this._cookies.has(name);
    }
    add(cookie) {
        return new Cookies(this._cookies.set(cookie.name, cookie));
    }
    delete(name) {
        return new Cookies(this._cookies.delete(name));
    }
    *[Symbol.iterator]() {
        yield* this._cookies.values();
    }
    toArray() {
        return [...this];
    }
    toJSON() {
        return this.toArray().map((cookie) => cookie.toJSON());
    }
    toString() {
        return this.toArray()
            .map((cookie) => cookie.toString())
            .join("; ");
    }
}
/**
 * @public
 */
(function (Cookies) {
    function from(json) {
        return Cookies.of(json.map((cookie) => Cookie.from(cookie)));
    }
    Cookies.from = from;
    function isCookies(value) {
        return value instanceof Cookies;
    }
    Cookies.isCookies = isCookies;
})(Cookies || (Cookies = {}));
//# sourceMappingURL=cookies.js.map